




















































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "ConfigStyle",
})

export default class ConfigStyle extends Vue {
  @Prop({required: true}) configName!: string;
  @Prop() fontList!: Array<string>;
  @Prop( {required: true }) config: any;
  @Prop() chartSet!: string;
  @Prop({ required: true }) type!: string;

  protected fontStyleList: Array<object> = [
    {
      value: 'normal',
      text: 'Regular',
    },
    {
      value: 'bold',
      text: 'Bold',
    },
    {
      value: 'italic',
      text: 'Italic',
    }
  ]
  protected fontSizeList: Array<number> = [6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 24, 36];

  private updateConfig() {
    this.$emit('updateConfig', this.config);
  }
}
